import { jwtDecode } from "jwt-decode";
import {
  CategoriesType,
  CourseType,
  PaymentsType,
  RepresentativeType,
  StatusType,
} from "../types/entitiesModel";

/**
 * To obtain the role of the user
 * @returns
 */
export const getUserRole = (token: string | null) => {
  if (token !== null) {
    const decodedToken = jwtDecode<{ data?: { role?: string } }>(token);

    if (decodedToken?.data?.role) {
      return decodedToken.data.role;
    } else {
      console.warn('El token no contiene la propiedad "role" dentro de "data"');
    }
  }

  return null;
};

export const getAllUserData = (token: string | null) => {
  if (token !== null) {
    const decodedToken = jwtDecode<{
      data?: { role?: string; email?: string; name?: string };
    }>(token);

    if (decodedToken?.data?.role) {
      return decodedToken.data;
    } else {
      console.warn('El token no contiene la propiedad "role" dentro de "data"');
    }
  }

  return null;
};

export function removeAccentsAndToLower(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export const fetchRepresentativeByUserEmail = async (
  email: string,
  token: string
): Promise<RepresentativeType | string> => {
  try {
    let options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(
      `/api/representatives/byemail?email=${email}`,
      options
    );

    if (!response.ok) {
      throw new Error("Error al obtener la información del representante");
    }

    const jsondata = await response.json();
    return jsondata;
  } catch (err) {
    if (err instanceof Error) {
      return err.message;
    } else {
      return "Error desonocido";
    }
  }
};

/**
 * to have categories to select
 */
export const fetchCategories = async (
  setLoading: (value: boolean) => void,
  setCategories: (value: CategoriesType[]) => void,
  setError: (value: string | null) => void
) => {
  setLoading(true);
  try {
    const response = await fetch(`appservice/categories/all`);

    if (!response.ok) {
      throw new Error("Error al obtener las categorías");
    }

    const jsondata = await response.json();
    setCategories(jsondata);
    setError(null);
  } catch (err) {
    setError("Error fetching categories");
    console.error("Error al cargar las categorías:", err);
  } finally {
    setLoading(false);
  }
};

/**
 * to have representatives to select
 */
export const fetchRepresentatives = async (
  setLoading: (value: boolean) => void,
  setRepresentatives: (value: RepresentativeType[]) => void,
  setError: (value: string | null) => void
) => {
  setLoading(true);
  try {
    const response = await fetch(`/api/representatives/all`);

    if (!response.ok) {
      throw new Error("Error al obtener los representantes");
    }

    const jsondata = await response.json();
    setRepresentatives(jsondata);
    setError(null);
  } catch (err) {
    setError("Error trayendo a los representantes");
    console.error("Error al cargar las representantes:", err);
  } finally {
    setLoading(false);
  }
};

export const fetchCourses = async (
  setLoading: (value: boolean) => void,
  setCourses: (value: CourseType[]) => void,
  setError: (value: string | null) => void
) => {
  setLoading(true);
  try {
    const response = await fetch(`/appservice/courses/all`);

    if (!response.ok) {
      throw new Error("Error al obtener los cursos");
    }

    const jsondata = await response.json();
    setCourses(jsondata);
    setError(null);
  } catch (err) {
    setError("Error trayendo a los cursos");
    console.error("Error al cargar los cursos:", err);
  } finally {
    setLoading(false);
  }
};

/**
 * Retrieves all the payments methods on the system for selects
 * @param setLoading
 * @param setCourses
 * @param setError
 */
export const fetchPayments = async (
  setLoading: (value: boolean) => void,
  setPayments: (value: PaymentsType[]) => void,
  setError: (value: string | null) => void
) => {
  setLoading(true);
  try {
    let options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(`/appservice/payments/all`, options);

    if (!response.ok) {
      throw new Error("Error al obtener los métodos de pago");
    }

    const jsondata = await response.json();
    setPayments(jsondata);
    setError(null);
  } catch (err) {
    setError("Error trayendo los métodos de pago");
    console.error("Error al cargar los métodos de pago:", err);
  } finally {
    setLoading(false);
  }
};

export const fetchStatusForInvoicesSelect = async (
  setLoading: (value: boolean) => void,
  setStatus: (value: StatusType[]) => void,
  setError: (value: string | null) => void,
  token: string
) => {
  setLoading(true);
  try {
    let options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(`/api/status`, options);

    if (!response.ok) {
      throw new Error("Error al obtener los status");
    }

    const jsondata = await response.json();
    setStatus(jsondata);
    setError(null);
  } catch (err) {
    setError("Error trayendo los status");
    console.error("Error al cargar los status:", err);
  } finally {
    setLoading(false);
  }
};
